import { AssetInfoCard } from "components/AssetInfoCard";
import { StakeBox } from "components/staked-asset-page/StakeBox";
import { UnstakeBox } from "components/staked-asset-page/UnstakeBox";
import { UnstakeListBox } from "components/staked-asset-page/UnstakeListBox";
import { ConfigResponse } from "models/factory/ConfigResponse";
import { StakeResponse, StakingInfo } from "models/staking/StakeResponse";
import { StakingStatResponse } from "models/staking/StakingStatResponse";
import { UnstakeResponse } from "models/staking/UnstakeResponse";
import { BalanceResponse } from "models/token/BalanceResponse";
import { TokenInfoResponse } from "models/token/TokenInfoResponse";
import { useAsset } from "provider/AssetProvider";
import { useWallet } from "provider/WalletProvider";
import { useEffect, useState } from "react";
import { CLASSIC_CHAIN_ID, FACTORY_ADDRESS } from "utils/Constants";
import { fromDenom, numberPendek } from "utils/Helpers";
import { showSimpleModal } from "utils/Modals";
import { querySmartContract } from "utils/RpcHelpers";
import { showLoadingToast } from "utils/Toasts";

export function StakedAssetPage() {
    const { stakingAddress, tokenInfo, tokenAddress } = useAsset()
    const { address } = useWallet()

    const [stakingStat, setStakingStat] = useState<StakingStatResponse>()
    const [stakingInfo, setStakingInfo] = useState<StakingInfo>()
    const [balance, setBalance] = useState<BalanceResponse>()
    const [feeBalance, setFeeBalance] = useState<BalanceResponse>()
    const [factoryConfig, setFactoryConfig] = useState<ConfigResponse>();
    const [feeTokenInfo, setFeeTokenInfo] = useState<TokenInfoResponse>();

    const loadStakingStatInfo = async () => {
        try {
            const res: StakingStatResponse = await querySmartContract(stakingAddress!, { staking_stat: {} })
            console.log(res)
            setStakingStat(res)
        } catch (e) { }
    }

    useEffect(() => {
        if (stakingAddress) loadStakingStatInfo()
    }, [stakingAddress])

    const loadFeeTokenInfo = async () => {
        try {
            const tokenInfo: TokenInfoResponse = await querySmartContract(factoryConfig!.config.token_contract, {
                token_info: {}
            })
            setFeeTokenInfo(tokenInfo)
        } catch (e) { }
    }

    useEffect(() => {
        if (factoryConfig) loadFeeTokenInfo();
    }, [factoryConfig])

    const loadFactoryConfig = async () => {
        try {
            const config = await querySmartContract(FACTORY_ADDRESS, { config: {} })
            setFactoryConfig(config)
        } catch (e) { }
    }

    useEffect(() => {
        loadFactoryConfig()
    }, [])

    const loadStakingInfo = async () => {
        try {
            const { stake }: StakeResponse = await querySmartContract(stakingAddress!, { stake: { staker: address } })
            setStakingInfo(stake)
        } catch (e) { }
    }

    useEffect(() => {
        if (address && stakingAddress) loadStakingInfo()
    }, [address, stakingAddress])

    const loadBalance = async () => {
        const balance = await querySmartContract(tokenAddress!, { balance: { address } })
        setBalance(balance)
    }

    useEffect(() => {
        if (address && tokenAddress) loadBalance()
    }, [address, tokenAddress])

    const loadFeeBalance = async () => {
        const balance = await querySmartContract(factoryConfig!.config.token_contract!, { balance: { address } })
        setFeeBalance(balance)
    }

    useEffect(() => {
        if (address && factoryConfig) loadFeeBalance()
    }, [address, factoryConfig])

    return <div className="container-fluid flex-grow-1 container-p-y">
        <div className="row">
            <div className="col-12 col-md-6 mb-4">
                <div className="row">
                    <div className="col-6 mb-4">
                        <AssetInfoCard
                            label="Total Staking"
                            icon="dollar-circle"
                            color="warning"
                            tokenInfo={tokenInfo}
                            amount={fromDenom(Number(stakingStat?.total_staking ?? "0"), tokenInfo?.decimals ?? 6 ?? 6)} />
                    </div>
                    <div className="col-6 mb-4">
                        <AssetInfoCard
                            label="Total Staker"
                            icon="group"
                            color="success"
                            tokenInfo={{ symbol: "Staker", total_supply: "", decimals: 0, name: "" }}
                            amount={Number(stakingStat?.total_staker ?? "0")} />
                    </div>

                    <div className="col-6 mb-4">
                        <AssetInfoCard
                            label="Staked Asset"
                            icon="dollar"
                            color="primary"
                            tokenInfo={tokenInfo}
                            amount={fromDenom(Number(stakingInfo?.amount ?? "0"), tokenInfo?.decimals ?? 6 ?? 6)} />
                    </div>
                    <div className="col-6 mb-4">
                        <AssetInfoCard
                            label="Balance"
                            icon="wallet"
                            color="info"
                            tokenInfo={tokenInfo}
                            amount={fromDenom(Number(balance?.balance ?? "0"), tokenInfo?.decimals ?? 6 ?? 6)} />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <StakeBox
                    feeBalance={feeBalance}
                    onStakeComplete={() => {
                        loadStakingStatInfo()
                        loadBalance()
                        loadStakingInfo()
                    }}
                    balance={balance}
                    factoryConfig={factoryConfig}
                    feeTokenInfo={feeTokenInfo} />
                <div className="mb-4"></div>
                <UnstakeBox
                    feeBalance={feeBalance}
                    onUnstakeComplete={() => {
                        loadStakingStatInfo()
                        loadBalance()
                        loadStakingInfo()
                    }}
                    stakingInfo={stakingInfo}
                    factoryConfig={factoryConfig}
                    feeTokenInfo={feeTokenInfo} />
                <div className="mb-4"></div>
            </div>
        </div>
    </div>
}